define('js/views/PasswordInputView',[
    'js/lib/createElement',
    'js/lib/onceEvent'
], function (
    createElement,
    onceEvent
) {
    'use strict';

    function makePopup() {
        var messageContainer = createElement('div', 'message-container');
        var header = createElement('header', 'message-header');
        var content = createElement('div', 'body');

        header.appendChild(createElement('div', 'title', {textContent: 'This content is password-protected.'}));
        header.appendChild(createElement('div', 'sub-title', {textContent: 'Please enter the password to continue.'}));
        
        var form = createElement('form', 'password-form');
        var inputContainer = createElement('div', 'password-input-container');
        var passwordInput = createElement('input', 'password-input', {type: 'password', placeholder: 'Password'});
        var clearButton = createElement('button', 'password-clear', {
            type: 'button',
            innerHTML: '<svg role="presentation" viewBox="0 0 24 24" class="icon icon--size-x-small"><path d="M0 0h24v24H0V0z" fill="none"></path><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z"></path></svg>',
            title: 'Clear password',
            style: 'display: none;'
        });
        var toggleButton = createElement('button', 'password-toggle', {
            type: 'button',
            innerHTML: '<svg role="presentation" viewBox="0 0 24 24" class="icon icon--size-x-small"><path d="M0 0h24v24H0V0z" fill="none"></path><path d="M12 4C7 4 2.73 7.11 1 11.5 2.73 15.89 7 19 12 19s9.27-3.11 11-7.5C21.27 7.11 17 4 12 4zm0 12.5c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"></path></svg>',
            title: 'Show password',
            style: 'display: none;'
        });
        var progressCircle = createElement('div', 'loading', {
            innerHTML: `<svg role="progressbar" viewBox="0 0 24 24" class="progress-circle" aria-label="Loading…">
                <circle aria-hidden="true" class="progress-circle__path" cx="50%" cy="50%" r="10"></circle>
                <circle aria-hidden="true" class="progress-circle__fill" cx="50%" cy="50%" r="10" pathLength="100" stroke-dasharray="100" stroke-dashoffset="50"></circle>
            </svg>`
        });
        progressCircle.style.display = 'none';
        
        inputContainer.appendChild(passwordInput);
        inputContainer.appendChild(clearButton);
        inputContainer.appendChild(toggleButton);
        inputContainer.appendChild(progressCircle);
        form.appendChild(inputContainer);
        form.appendChild(createElement('div', 'error-message'));
        form.appendChild(createElement('button', 'submit-button', {type: 'submit', textContent: 'Open deck', disabled: true}));
        content.appendChild(form);

        messageContainer.appendChild(header);
        messageContainer.appendChild(content);

        return messageContainer;
    }

    function PasswordInputView(onSubmit) {
        this.el = createElement('div', 'PasswordInputView vc-bg');
        this.el.appendChild(makePopup());

        // Return a promise that resolves when a password has been entered
        // and the submit button clicked.
        var view = this;

        var input = this.el.querySelector('.password-input');
        var button = this.el.querySelector('.submit-button');
        var clearButton = this.el.querySelector('.password-clear');
        var toggleButton = this.el.querySelector('.password-toggle');
        var progressCircle = this.el.querySelector('.loading');
        var errorMessage = this.el.querySelector('.error-message');

        function submit() {
            var password = input.value.trim();

            if (!password) {
                errorMessage.textContent = 'Please enter a password.';
                return;
            }

            // Show loading state and disable all controls
            input.disabled = true;
            button.disabled = true;
            clearButton.disabled = true;
            toggleButton.disabled = true;
            clearButton.style.display = 'none';
            toggleButton.style.display = 'none';
            progressCircle.style.display = 'block';
            errorMessage.textContent = '';

            onSubmit(password);
        }

        function updateButtonVisibility() {
            var hasValue = input.value.length > 0;
            clearButton.style.display = hasValue ? 'block' : 'none';
            toggleButton.style.display = hasValue ? 'block' : 'none';
            button.disabled = !hasValue;
            
            // Clear invalid state when user starts typing
            input.removeAttribute('aria-invalid');
            input.classList.remove('invalid');
            var errorMessage = this.el.querySelector('.error-message');
            errorMessage.textContent = '';
        }

        function clearPassword() {
            input.value = '';
            input.focus();
            // Clear any error messages when clearing
            if (errorMessage.textContent === 'Please enter a password.') {
                errorMessage.textContent = '';
            }
            // Clear invalid state when clearing
            input.removeAttribute('aria-invalid');
            input.classList.remove('invalid');
            // Update button visibility after clearing
            updateButtonVisibility();
        }

        function togglePasswordVisibility() {
            if (input.type === 'password') {
                input.type = 'text';
                toggleButton.innerHTML = '<svg role="presentation" viewBox="0 0 24 24" class="icon icon--size-x-small"><path d="M0 0h24v24H0V0zm0 0h24v24H0V0zm0 0h24v24H0V0zm0 0h24v24H0V0z" fill="none"></path><path d="M12 6.5c2.76 0 5 2.24 5 5 0 .51-.1 1-.24 1.46l3.06 3.06c1.39-1.23 2.49-2.77 3.18-4.53C21.27 7.11 17 4 12 4c-1.27 0-2.49.2-3.64.57l2.17 2.17c.47-.14.96-.24 1.47-.24zM2.71 3.16c-.39.39-.39 1.02 0 1.41l1.97 1.97C3.06 7.83 1.77 9.53 1 11.5 2.73 15.89 7 19 12 19c1.52 0 2.97-.3 4.31-.82l2.72 2.72c.39.39 1.02.39 1.41 0 .39-.39.39-1.02 0-1.41L4.13 3.16c-.39-.39-1.03-.39-1.42 0zM12 16.5c-2.76 0-5-2.24-5-5 0-.77.18-1.5.49-2.14l1.57 1.57c-.03.18-.06.37-.06.57 0 1.66 1.34 3 3 3 .2 0 .38-.03.57-.07L14.14 16c-.65.32-1.37.5-2.14.5zm2.97-5.33c-.15-1.4-1.25-2.49-2.64-2.64l2.64 2.64z"></path></svg>';
                toggleButton.title = 'Hide password';
            } else {
                input.type = 'password';
                toggleButton.innerHTML = '<svg role="presentation" viewBox="0 0 24 24" class="icon icon--size-x-small"><path d="M0 0h24v24H0V0z" fill="none"></path><path d="M12 4C7 4 2.73 7.11 1 11.5 2.73 15.89 7 19 12 19s9.27-3.11 11-7.5C21.27 7.11 17 4 12 4zm0 12.5c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"></path></svg>';
                toggleButton.title = 'Show password';
            }
        }

        var form = this.el.querySelector('.password-form');

        form.addEventListener('submit', function(e) {
            e.preventDefault();
            submit();
        });
        button.addEventListener('click', submit);
        clearButton.addEventListener('click', clearPassword);
        toggleButton.addEventListener('click', togglePasswordVisibility);
        input.addEventListener('keydown', function (e) {
            if (e.key === 'Enter') {
                submit();
            }
        });
        input.addEventListener('input', updateButtonVisibility);
        input.addEventListener('paste', function() {
            // Use setTimeout to ensure the paste operation completes before checking
            setTimeout(updateButtonVisibility, 0);
        });

        this.animate().then(function () {
            input.focus();
        });
    }

    function animateOut(view) {
        view.el.classList.add('animate-out');

        return onceEvent(view.el, 'animationend').then(function () {
            view.el.remove();
        });
    }

    PasswordInputView.prototype.animate = function () {
        var view = this;

        view.el.classList.add('animate-in');

        return onceEvent(view.el, 'animationend').then(function () {
            view.el.classList.remove('animate-in');
        });
    };

    PasswordInputView.prototype.remove = function () {
        var view = this;

        if (!view.el.classList.contains('animate-in')) {
            return this.animateOut(view);
        }

        return onceEvent(view.el, 'animationend').then(function () {
            return animateOut(view);
        });
    };

    PasswordInputView.prototype.displayError = function(message) {
        var input = this.el.querySelector('.password-input');
        var button = this.el.querySelector('.submit-button');
        var clearButton = this.el.querySelector('.password-clear');
        var toggleButton = this.el.querySelector('.password-toggle');
        var progressCircle = this.el.querySelector('.loading');
        var errorMessage = this.el.querySelector('.error-message');

        // Hide loading state and re-enable all controls
        input.disabled = false;
        button.disabled = false;
        clearButton.disabled = false;
        toggleButton.disabled = false;
        progressCircle.style.display = 'none';

        // Show error message and mark input as invalid
        errorMessage.textContent = message;
        input.classList.add('invalid');

        // Update button visibility based on current input value
        if (input.value.length > 0) {
            clearButton.style.display = 'block';
            toggleButton.style.display = 'block';
            button.disabled = false;
        } else {
            clearButton.style.display = 'none';
            toggleButton.style.display = 'none';
            button.disabled = true;
        }

        // Focus back on the input field
        input.focus();
    };

    return PasswordInputView;
});
